export default "__VITE_ASSET__BAnnklVh__"